module.exports = __webpack_public_path__ + "media/img/android-icon-36x36-66d84f9bcacb5e89720577e1040999f3.png";